var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77197 9C8.06948 9 7.5 9.56948 7.5 10.272V22.5V28.187C7.5 28.7881 8.25705 29.0537 8.6326 28.5842L13.5 22.5L27.228 22.5C27.9305 22.5 28.5 21.9305 28.5 21.228V10.272C28.5 9.56948 27.9305 9 27.228 9H8.77197Z",
    stroke: "#3D3E40",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 16.5,
    r: 1.5,
    fill: "#3D3E40"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.043,
    cy: 16.5,
    r: 1.5,
    fill: "#3D3E40"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5859,
    cy: 16.5,
    r: 1.5,
    fill: "#3D3E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.6b3d98080fbce61569380bb6e2e09bc3.svg";
export { ForwardRef as ReactComponent };